import { Box, FormControl, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

type Props = {
  labels: { description: string; id: string; name: string }[];
  updateParent: (value: string) => void;
};

const LabelSelect = ({ labels, updateParent }: Props) => {
  const [selected, setSelected] = useState(labels.length > 0 ? labels[0].name : '');

  useEffect(() => {
    updateParent(selected);
  }, [selected, updateParent]);

  const handleChange = (event: SelectChangeEvent) => {
    setSelected(event.target.value as string);
    updateParent(event.target.value as string);
  };

  return (
    <Box
      display={'flex'}
      alignItems={'center'}
      gap={1}
      height={'100%'}
      width={'100%'}
      px={1.25}
      py={0.75}
      borderRadius={2}
      border={'1px solid #d7dde7'}
      bgcolor={'#f8fafc'}
    >
      <Typography fontSize={12} fontWeight={700} color={'#334155'} whiteSpace={'nowrap'}>
        Company
      </Typography>
      <FormControl fullWidth size='small'>
        <Select
          id='label-select'
          value={selected}
          onChange={handleChange}
          displayEmpty
          sx={{
            bgcolor: '#ffffff',
            borderRadius: 1.5,
            minHeight: 38,
            '& .MuiSelect-select': {
              py: 0.75,
              fontSize: 13,
              color: '#0f172a',
            },
          }}
        >
          {labels.map((label) => {
            return (
              <MenuItem key={label.id} value={label.name}>
                {label.name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
};

export default LabelSelect;
